import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import SortableTree, {
  getTreeFromFlatData,
  getFlatDataFromTree
} from "react-sortable-tree";
import {
  Page,
  StyledButton,
  TextField,
  Loadable,
  Fab,
  If
} from "components/support";
import { colors } from "assets";

import CategoryUnit from "./category-unit";
import CategoryForm from "./form";
import "./styles.css";

export default class CategoryListView extends Component {
  state = {
    expanded: {},
    filter: "",
    editingFilter: false
  };

  treeDataFromCategories = categories => {
    const { presenter } = this.props;

    const flatData = categories.map(category => ({
      uuid: category.uuid,
      category_uuid: category.category_uuid,
      expanded: this.state.expanded[category.uuid] || false,
      original: category,
      title: () => (
        <CategoryUnit
          category={category}
          onRequestCreate={() => presenter.createCategory(category.uuid)}
          onRequestEdit={() => presenter.editCategory(category)}
          onRequestDelete={() => presenter.deleteCategory(category)}
        />
      )
    }));

    return getTreeFromFlatData({
      flatData,
      getKey: node => node.uuid,
      getParentKey: node => node.category_uuid,
      rootKey: null
    });
  };

  handleTreeVisibilityChange = ({ node, expanded }) => {
    this.setState(prevState => ({
      expanded: {
        ...prevState.expanded,
        [node.uuid]: expanded
      }
    }));
  };

  handleTreeMove = ({ treeData, nextTreeIndex }) => {
    const flatData = getFlatDataFromTree({
      treeData,
      getNodeKey: node => node.uuid
    });
    const { node, parentNode } = flatData[nextTreeIndex];
    const { presenter } = this.props;
    const targetCategory = parentNode ? parentNode.original : null;

    if (node.original.category_uuid !== targetCategory) {
      presenter.onMoveCategory(node.original, targetCategory);
    }
  };

  nodeMatchesSearch = ({ node, searchQuery }) =>
    searchQuery &&
    searchQuery.length > 0 &&
    node.original.name.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;

  expandNodesForMatches = (treeData, matches) => {
    if (!this.state.editingFilter) {
      return;
    }

    const flatData = getFlatDataFromTree({
      treeData,
      getNodeKey: node => node.uuid,
      ignoreCollapsed: false
    });

    const expanded = {};

    matches.forEach(({ path }) => {
      path.forEach(pathIndex => {
        const uuid = flatData[pathIndex].node.uuid;
        if (!this.state.expanded[uuid]) {
          expanded[uuid] = true;
        }
      });
    });

    if (Object.keys(expanded).length > 0) {
      this.setState(prevState => ({
        expanded: {
          ...prevState.expanded,
          ...expanded
        }
      }));
    }
  };

  handleFilterChange = value => {
    this.setState({ filter: value, editingFilter: true });
  };

  collapseAll = () => this.setState({ expanded: {}, editingFilter: false });
  expandAll = categories => {
    const expanded = {};
    categories.forEach(category => (expanded[category.uuid] = true));
    this.setState({ expanded, editingFilter: false });
  };

  render() {
    const { presenter, viewModel } = this.props;
    const { loading, categories, form } = viewModel;
    const { filter } = this.state;

    const nestedTree = this.treeDataFromCategories(categories);

    return (
      <Page>
        <Row>
          <Col xs={12}>
            <Typography type="display1" className="pb-sm">
              Categorias
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Paper elevation={1} className="mb-md p-sm">
              <Typography type="headline">Filtro</Typography>
              <Row bottom="xs">
                <Col xs={12} lg={8}>
                  <TextField
                    fullWidth
                    label="Nome da Categoria"
                    value={filter}
                    onChange={(_, value) => this.handleFilterChange(value)}
                  />
                </Col>
                <Col xs={6} lg={2}>
                  <StyledButton
                    fullWidth
                    primary
                    label="Expandir todas"
                    onTouchTap={() => this.expandAll(categories)}
                  />
                </Col>
                <Col xs={6} lg={2}>
                  <StyledButton
                    fullWidth
                    primary
                    label="Recolher todas"
                    onTouchTap={() => this.collapseAll()}
                  />
                </Col>
              </Row>
            </Paper>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Paper elevation={1} className="p-sm">
              <Loadable loading={loading}>
                <If test={categories.length > 0}>
                  <SortableTree
                    rowHeight={52}
                    isVirtualized={false}
                    treeData={nestedTree}
                    onChange={() => {}}
                    onVisibilityToggle={this.handleTreeVisibilityChange}
                    onMoveNode={this.handleTreeMove}
                    searchMethod={({ node, searchQuery }) =>
                      this.nodeMatchesSearch({ node, searchQuery })
                    }
                    searchQuery={filter}
                    searchFinishCallback={matches =>
                      this.expandNodesForMatches(nestedTree, matches)
                    }
                  />
                </If>

                <If test={categories.length === 0}>
                  <div className="rst__noDataFound">
                    <span>Nenhuma categoria encontrada</span>
                  </div>
                </If>
              </Loadable>
            </Paper>
          </Col>
        </Row>

        <CategoryForm
          loading={loading}
          visible={form.visible}
          category={form.category}
          mode={form.mode}
          onClose={entityCreated => presenter.onCloseForm(entityCreated)}
          categoryList={categories || []}
        />

        <Fab
          backgroundColor={colors.button.secondary}
          onClick={() => presenter.createCategory(null)}
          icon="add"
          tooltip="Adicionar Categoria"
        />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/category/list/view.jsx